import React from "react";

import { makeStyles } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import CheckIcon from "@material-ui/icons/Check";
import { useHistory } from "react-router-dom";

import RbFlexView from "components/RbFlexView";
import RbFlexViewItem from "components/RbFlexViewItem";
import RbGrid from "components/RbGrid";
import RbHeader from "components/RbHeader";
import RbScrollView from "components/RbScrollView";

const examples = [
  {
    name: "Product List",
    to: "/examples/products",
    features: [
      "Responsiveness using CSS and Javascript",
      "Search params pattern",
      "Rows with expanded details",
      "Paginated data",
    ],
  },
  {
    name: "Product Form",
    to: "/examples/products/new",
    features: [
      "Responsiveness using CSS",
      "Form validation",
      "Autocompleted asyncronous",
    ],
  },
  {
    name: "Basic",
    to: "/examples/basic",
    features: [
      "Responsiveness using CSS and Javascript",
      "Make easy to create basic screens",
      "Update data in the entire application",
      "Alert pattern",
    ],
  },
  {
    name: "Cars",
    to: "/examples/cars",
    features: [
      "Responsiveness using CSS",
      "Search and sort on the browser",
      "Edit data on rows",
      "Alert pattern",
    ],
  },
];

const useStyles = makeStyles({
  card: {
    height: "100%",
  },
  actionArea: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    height: "100%",
  },
});

function ExamplesScreen() {
  const history = useHistory();

  const classes = useStyles();

  return (
    <RbFlexView direction="column">
      <RbFlexViewItem>
        <RbHeader title="Examples" />
      </RbFlexViewItem>
      <RbFlexViewItem
        flex="1"
        bgcolor="custom.bg.100"
        borderTop={1}
        borderColor="custom.border.200"
      >
        <RbScrollView>
          <RbGrid
            container
            m={{ xs: 2, lg: 10 }}
            columnGap={{ xs: 2, lg: 10 }}
            rowGap={{ xs: 2, lg: 10 }}
          >
            {examples.map((example) => (
              <RbGrid key={example.name} item xs={12} md={3}>
                <Card className={classes.card}>
                  <CardActionArea
                    className={classes.actionArea}
                    onClick={() => history.push(example.to)}
                  >
                    <CardMedia
                      image="/static/images/cards/contemplative-reptile.jpg"
                      title="Contemplative Reptile"
                    />
                    <CardContent>
                      <Typography gutterBottom variant="h5" component="h2">
                        {example.name}
                      </Typography>
                      <List dense>
                        {example.features.map((feature) => (
                          <ListItem key={feature}>
                            <ListItemIcon>
                              <CheckIcon />
                            </ListItemIcon>
                            <ListItemText primary={feature} />
                          </ListItem>
                        ))}
                      </List>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </RbGrid>
            ))}
          </RbGrid>
        </RbScrollView>
      </RbFlexViewItem>
    </RbFlexView>
  );
}

export default React.memo(ExamplesScreen);
